export default __webpack_public_path__ + "static/media/gold_wave.21ddf492.svg";